import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </p>
        )}
        <h2 className="heading-font mt-2 text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        )}
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {action}
        {linkTo && (
          <Link
            to={linkTo}
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            {linkLabel}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true" />
            </span>
          </Link>
        )}
      </div>
    </div>
  );
}